/**
 * Generic `file_job`/`file_job_request` persistence carries no ZIP-specific
 * column — `type` is what selects the handler — so this enum is expected to
 * grow as later job types are added.
 *
 * `ZIP` is the only client-creatable type. `ZIP_INSPECTION` is registered by
 * the system when a ZIP upload is confirmed and is never accepted from a
 * client.
 */
export enum FileJobType {
	ZIP = 'zip',
	ZIP_INSPECTION = 'zip_inspection',
}

/**
 * A File Job's durable lifecycle status, stored as a text column backed by
 * this enum (matching `MultipartSessionStatus`/`FileProcessingResultStatus`).
 *
 * `EXPIRED` is never written to `file_job.status` — a `READY` row past its
 * `expiresAt` is reinterpreted as `EXPIRED` on every read path instead, so
 * correctness never waits on a sweeper. It is still a first-class member of
 * this enum because it is a real value every status-reporting API surface
 * returns.
 */
export enum FileJobStatus {
	QUEUED = 'QUEUED',
	PROCESSING = 'PROCESSING',
	READY = 'READY',
	FAILED = 'FAILED',
	EXPIRED = 'EXPIRED',
}

/**
 * Whether a `QUEUED` job's execution-request publish is known to have
 * succeeded. A job commits as `PENDING`; the creating request awaits the
 * publish and marks it `DISPATCHED` only after it succeeds (ADR-0024). A
 * `PENDING` job past the staleness threshold is republished by the mandatory
 * reconciler rather than relying on the client to retry.
 */
export enum FileJobDispatchStatus {
	PENDING = 'PENDING',
	DISPATCHED = 'DISPATCHED',
}
